/* eslint-disable no-eval */
import React from 'react';
import { Grid, Header, Table } from 'semantic-ui-react';
import { LocaleWithEmoji } from '../Domain/LocaleWithEmoji';
import { useAllLocales } from '../hooks/useLocales';
import { evenSplit } from '../utils/array';
import { Card } from './Card';
import { LiveValue } from './LiveValue';

interface AllLocalesProps {
	evalWithLocale: (locale: string) => string;
}

export const AllLocales: React.FC<AllLocalesProps> = ({ evalWithLocale }) => {
	const [locales] = useAllLocales();
	return (
		<Card marginx="a" marginy="b">
			<Header as="h2">other locales</Header>
			<Grid columns={2} stackable divided>
				{evenSplit.map((predicate) => (
					<Grid.Column key={predicate.toString()}>
						<Table basic="very" celled>
							<Table.Body>
								{locales
									.filter((_, i) => predicate(i))
									.map((l) => new LocaleWithEmoji(l))
									.map((l) => (
										<Table.Row key={l.baseName}>
											<Table.Cell width={2}>{l.baseNameWithEmoji}</Table.Cell>
											<Table.Cell width={10}>
												<LiveValue
													callback={() =>
														eval(evalWithLocale(l.baseName))
													}
												/>
											</Table.Cell>
										</Table.Row>
									))}
							</Table.Body>
						</Table>
					</Grid.Column>
				))}
			</Grid>
		</Card>
	);
};
